/**
 * @todo create a another function to check if attribute exists.
 * @param currentValue
 * @param compareValue
 * @return {boolean}
 */
export default function( currentValue, compareValue ) {
	return currentValue === compareValue;
}